import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const CircleProgressBar = ({ percent }) => {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress
        variant="determinate"
        value={percent}
        size={40}
        style={{ color: "#00b65c" }}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
          style={{ color: "white", fontSize: "12px" }}
        >{`${Math.round(percent)}%`}</Typography>
      </Box>
    </Box>
  );
};

export default CircleProgressBar;
